module.exports = __webpack_public_path__ + "img/40_34.8a791599.png";